import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import campaignEn from './locales/en/campaign.json';
import commonEn from './locales/en/common.json';
import coupon_promotionEn from './locales/en/coupon_promotion.json';
import pageEn from './locales/en/page.json';
import paymentEn from './locales/en/payment.json';
import projectEn from './locales/en/project.json';
import project_pageEn from './locales/en/project_page.json';
import tableEn from './locales/en/table.json';
import campaign from './locales/ko/campaign.json';
import common from './locales/ko/common.json';
import coupon_promotion from './locales/ko/coupon_promotion.json';
import page from './locales/ko/page.json';
import payment from './locales/ko/payment.json';
import project from './locales/ko/project.json';
import project_page from './locales/ko/project_page.json';
import table from './locales/ko/table.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // debug: true,'
    ns: ['common', 'table', 'page', 'project', 'payment', 'coupon_promotion'],
    fallbackLng: 'en',
    // 로케일 JSON 은 전부 평면 구조이고, 'code.vietnam'·'influencerType.beauty' 처럼
    // 점이 든 키를 그대로 쓴다. 기본값('.')이면 i18next 가 이를 중첩 경로로 해석해
    // code → vietnam 을 찾다 실패하고 키 문자열을 그대로 출력한다.
    // 중첩된 키를 쓰는 로케일 파일은 하나도 없으므로 구분자를 끈다.
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        common: commonEn,
        table: tableEn,
        project: projectEn,
        page: pageEn,
        payment: paymentEn,
        coupon_promotion: coupon_promotionEn,
        campaign: campaignEn,
        project_page: project_pageEn,
      },
      ko: {
        common,
        table,
        project,
        page,
        payment,
        coupon_promotion,
        campaign,
        project_page,
      },
    },
  });

export default i18n;
